import { FloatingLabelInput } from "@ucchub/ui";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

interface MFAFormProps {
  twoFactor: string;
  onTwoFactor: (twoFactor: string) => void;
}

const MFAForm = ({ twoFactor, onTwoFactor }: MFAFormProps) => {
  const { t } = useTranslation();

  // Focus the MFA Input element on initial load.
  const mfaFieldRef = useRef<HTMLInputElement>(null);
  useEffect(() => mfaFieldRef.current?.focus(), []);

  return (
    <div>
      <FloatingLabelInput
        label={t("core:auth:mfa_securitycode")}
        type="password"
        domRef={mfaFieldRef}
        value={twoFactor}
        id="password"
        onChange={(e) => onTwoFactor(e.target.value)}
      />
    </div>
  );
};

export default MFAForm;
